module.exports = __webpack_public_path__ + "img/hb_zhCn.5c71b303.png";